






























































































































































import Vue from 'vue';
import customerVuex from '../../vuex/common';
import { CustomerMergeProp } from '../../models/CustomerImport';
import CustomerProp from '../../models/CustomerProp';
import commonClient from '../../../common/apis';
import { TaskType } from '../../../common/models/TaskType';

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    started: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const propFields: { [key: string]: string } = {};
    const overwrites: { [key: string]: number } = {};
    return {
      interval: null,
      keyColumn: null,
      keyFieldName: null,
      showSyncFields: false,
      matchFieldConfirmed: false,
      syncFieldsConfirmed: false,
      importLoading: false,
      syncing: false,
      importPercent: 0,
      hackId: 0,
      propFields,
      overwrites,
    };
  },
  computed: {
    matchProps(): CustomerProp[] {
      const whiteBuiltInFields = [
        'wxProps.openid',
        'phone',
        'memberInfo.cardNo',
        'citizenId',
        'wechat',
        'email',
      ];
      return this.customerState.props.filter((p: CustomerProp) => {
        return whiteBuiltInFields.includes(p.fieldName) || !p.builtIn;
      });
    },
    syncProps(): CustomerProp[] {
      const whiteBuiltInFields = [
        'phone',
        'realName',
        'birth',
        'citizenId',
        'email',
        'address',
        'edu',
        'wechat',
        'area',
        'maritalStatus',
        'career',
        'industry',
        'income',
        'hobby',
        'telephone',
        'qq',
      ];
      return this.customerState.props.filter((p: CustomerProp) => {
        return whiteBuiltInFields.includes(p.fieldName) || !p.builtIn;
      });
    },
    importColumns(): string[] {
      return this.customerImport.columns.filter((c: string) => c !== this.keyColumn);
    },
  },
  methods: {
    reUpload() {
      this.$store.commit('RESET_CUSTOMER_IMPORT');
    },
    confirmMatchField() {
      if (!this.keyColumn || !this.keyFieldName) {
        this.$Message.warning('请选择检验字段');
      } else {
        const prop = this.customerState.props.find(
          (p: CustomerProp) => p.fieldName === this.keyFieldName
        );
        const ci = this.customerImport;
        ci.keyColumn = this.keyColumn;
        ci.keyProp = {
          field: prop.fieldName,
          fieldType: prop.propType,
          builtIn: prop.builtIn,
          overwrite: false,
        } as CustomerMergeProp;
        this.$store.commit('SET_CUSTOMER_IMPORT', ci);
        this.matchFieldConfirmed = true;
        this.showSyncFields = true;
      }
    },
    displayNameOfProp(p?: CustomerMergeProp): string {
      if (!p) {
        return '不导入';
      } else {
        const prop = this.customerState.props.find((prop: CustomerProp) => prop.fieldName === p.field);
        return prop ? prop.propName : '';
      }
    },
    displayPropName(fieldName: string): string {
      const p = this.customerState.props.find((p: CustomerProp) => p.fieldName === fieldName);
      if (fieldName === 'none') {
        return '不导入';
      } else {
        return p ? p.propName : '';
      }
    },
    updatePropField(col: string, value: string) {
      this.propFields[col] = value;
      this.hackId++;
    },
    updateOverwrites(col: string, value: number) {
      this.overwrites[col] = value;
      this.hackId++;
    },
    confirmSyncField() {
      const fields: string[] = [];
      for (const k of Object.keys(this.propFields)) {
        if (this.propFields[k] === null && k !== this.keyColumn) {
          this.$Message.warning('请选择客户库中的字段');
          return ;
        }
        if (fields.includes(this.propFields[k])) {
          this.$Message.warning('需导入的客户库字段不能重复');
          return ;
        }
        if (this.propFields[k] !== null && this.propFields[k] !== 'none') {
          fields.push(this.propFields[k]);
        }
      }
      if (fields.length < 1) {
        this.$Message.warning('请至少设置一个需导入的客户库字段');
        return ;
      }
      if (this.customerImport.total > 10000) {
        this.$Message.warning('需导入的数据行数不能超过1万');
        return ;
      }
      const ic = this.customerState.customerImport;
      ic.props = {};
      Object.keys(this.propFields).forEach((k: string) => {
        if (this.propFields[k] !== 'none' && k !== this.keyColumn) {
          const prop = this.customerState.props.find((p: CustomerProp) => {
            return p.fieldName === this.propFields[k];
          });
          ic.props[k] = {
            field: prop.fieldName,
            fieldType: prop.propType,
            builtIn: prop.builtIn,
            overwrite: this.overwrites[k] === 1,
          } as CustomerMergeProp;
        }
      });
      this.$store.commit('SET_CUSTOMER_IMPORT', ic);
      this.syncFieldsConfirmed = true;
    },
    revizeMatchField() {
      this.matchFieldConfirmed = false;
      this.syncFieldsConfirmed = false;
      this.showSyncFields = false;
    },
    confirmImport() {
      this.importLoading = true;
      commonClient.createTask({
        input: {
          FieldImport: {
            excelUrl: this.customerImport.excelUrl,
            keyColumn: this.customerImport.keyColumn,
            keyProp: this.customerImport.keyProp,
            props: this.customerImport.props,
          },
        },
        taskType: TaskType.FieldImport,
        expectCount: this.customerImport.total,
      }).success(r => {
        this.$Message.success('创建数据导入任务成功，请等待');
        this.syncing = true;
        this.$emit('start');
        this.startCheckStatus();
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
        this.importLoading = false;
      }).error((e) => {
        this.$Message.error(e.toString());
        this.importLoading = false;
      });
    },
    startCheckStatus() {
      this.interval = setInterval(() => {
        commonClient.getTasksByTypes({
          page: 1,
          size: 1,
          tpes: [11],
        }).success(r => {
          if (r.tasks && r.tasks.length > 0) {
            const task = r.tasks[0];
            if (task['result'] !== null) {
              if (task['result'] === -1) {
                this.$emit('fail', task.id);
              } else {
                this.$emit('success', {
                  stat: task['taskOutput']['FieldImportStat'],
                  id: task.id,
                });
              }
              clearInterval(this.interval);
            } else {
              this.importPercent = (r.tasks[0].cursor / this.customerImport.total) * 100;
              this.importPercent = Math.floor(this.importPercent > 99 ? 99 : this.importPercent);
            }
          }
        });
      }, 1000);
    },
  },
  mounted() {
    for (const col of this.customerImport.columns) {
      this.propFields[col] = null;
      this.overwrites[col] = 1;
    }
    if (this.started) {
      this.syncing = true;
      this.matchFieldConfirmed = true;
      this.syncFieldsConfirmed = true;
      this.showSyncFields = true;
      this.startCheckStatus();
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
});
